import useAutosize from "../../hooks/use-auto-size";
import { IoIosSend } from "react-icons/io";

function ChatInput({ newMessage, isLoading, setNewMessage, submitNewMessage }) {
  const textareaRef = useAutosize(newMessage);
  const isDisabled = !newMessage || isLoading;

  function handleKeyDown(e) {
    if (e.keyCode === 13 && !e.shiftKey && !isLoading) {
      e.preventDefault();
      submitNewMessage();
    }
  }

  return (
    <div className=" py-4">
      <div className="p-1.5 bg-primary-blue/35 rounded-3xl z-50 font-mono origin-bottom animate-chat duration-400">
        <div className="pr-0.5 bg-white relative shrink-0 rounded-3xl overflow-hidden ring-primary-blue ring-1 focus-within:ring-2 transition-all">
          <textarea
            className="block w-full max-h-[140px] py-2 px-4 pr-11 rounded-3xl resize-none placeholder:text-primary-blue placeholder:leading-4 placeholder:-translate-y-1 sm:placeholder:leading-normal sm:placeholder:translate-y-0 focus:outline-none"
            ref={textareaRef}
            rows="1"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ask me a question..."
          />
          <button
            className={`ai-chat-submit-btn absolute top-1/2 -translate-y-1/2 right-3 p-1 ${isDisabled ? "disabled" : "cursor-pointer"}`}
            onClick={submitNewMessage}
            disabled={isDisabled}
          >
            <IoIosSend size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatInput;
